define.alias("shared/modifiers/call-after-hover", "calendar/modifiers/call-after-hover");